import { useEffect, useState } from "react";
import { Box, IconButton, Paper, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Dropzone from "react-dropzone";
import ConfirmDialog from "../dialogs/ConfirmDialog";
import {
  fetchDocumentos,
  uploadDocumentos,
  descargarDocumento,
  deleteDocument,
} from "../../../components/functions/Projects";

const DocumentosTab = ({ API_URL, trabajoId, setGlobalLoading, notify }) => {
  const [documentos, setDocumentos] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedFileId, setSelectedFileId] = useState(null);

  useEffect(() => {
    const run = async () => {
      try {
        setGlobalLoading(true);
        const res = await fetchDocumentos(API_URL, trabajoId);
        setDocumentos(res || []);
      } finally {
        setGlobalLoading(false);
      }
    };
    if (trabajoId) run();
  }, [API_URL, trabajoId, setGlobalLoading]);

  const subirDocumentosHandler = async (file) => {
    if (!file) {
      notify("Por favor, selecciona un documento válido.");
      return;
    }
    try {
      setGlobalLoading(true);
      await uploadDocumentos(API_URL, file, trabajoId);
      const res = await fetchDocumentos(API_URL, trabajoId);
      setDocumentos(res || []);
      notify("Documento subido con éxito");
    } finally {
      setGlobalLoading(false);
    }
  };

  const handleDownloadDocument = async (documento) => {
    const queryParams = documento.link.split("?")[1];
    const type = `application/${queryParams.split("tipoArchivo=")[1]}`;
    const res = await descargarDocumento(
      API_URL,
      documento.nombre,
      queryParams
    );
    const blob = new Blob([res], { type });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = documento.nombre;
    link.click();
    URL.revokeObjectURL(url);
  };

  const handleDeleteDocument = async () => {
    try {
      setGlobalLoading(true);
      await deleteDocument(API_URL, selectedFileId);
      setDocumentos(documentos.filter((d) => d.id !== selectedFileId));
      notify("Documento borrado con éxito");
    } finally {
      setGlobalLoading(false);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Dropzone
        accept={{ "application/pdf": [".pdf"] }}
        onDrop={(files) => subirDocumentosHandler(files[0])}
      >
        {({ getRootProps, getInputProps }) => (
          <section
            style={{
              border: "2px dashed #999",
              borderRadius: 8,
              textAlign: "center",
              backgroundColor: "#f9f9f9",
              color: "#666",
              fontSize: 16,
              cursor: "pointer",
              transition: "background-color 0.3s, border-color 0.3s",
            }}
          >
            <div {...getRootProps()} style={{ padding: 40 }}>
              <input {...getInputProps()} />
              <p>Documentos</p>
              <p>{"(Seleccionar o arrastrar archivo) (PDF)"}</p>
            </div>
          </section>
        )}
      </Dropzone>

      {documentos.length > 0 ? (
        <Paper sx={{ height: "67vh", width: "100%", mt: 2 }} elevation={3}>
          {documentos.map((documento) => (
            <Box
              key={documento.id}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 2,
                borderBottom: "1px solid #ccc",
              }}
            >
              <Typography
                onClick={() => handleDownloadDocument(documento)}
                variant="body1"
                sx={{
                  cursor: "pointer",
                  textDecoration: "underline",
                  color: "rgb(247, 144, 30)",
                }}
              >
                {documento.nombre}
              </Typography>
              <IconButton
                onClick={() => {
                  setSelectedFileId(documento.id);
                  setShowConfirm(true);
                }}
                color="error"
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          ))}
        </Paper>
      ) : (
        <Typography sx={{ textAlign: "center", mt: 2 }} variant="body1">
          Sin documentos
        </Typography>
      )}

      <ConfirmDialog
        open={showConfirm}
        title="Confirmación"
        content="¿Seguro que desea borrar este documento?"
        onClose={() => setShowConfirm(false)}
        onConfirm={() => {
          setShowConfirm(false);
          handleDeleteDocument();
        }}
      />
    </Box>
  );
};

export default DocumentosTab;
